// extracted by mini-css-extract-plugin
export default {"modal":"ConfigEditor_modal__7tvk0","config-actions-container":"ConfigEditor_config-actions-container__9s7mx"};